// Dates and numbers in the portal's active language (Constitution §5 with the
// locale taken from lib/i18n). English keeps "en-US", so English output is unchanged.

import { dateLocale, t, uiLocale } from "./index";

type DateInput = string | number | Date;

export function formatDate(
  value: DateInput,
  options: Intl.DateTimeFormatOptions = { year: "numeric", month: "short", day: "numeric" },
  englishLocale = "en-US",
): string {
  return new Date(value).toLocaleDateString(dateLocale(englishLocale), options);
}

export function formatDateTime(
  value: DateInput,
  options: Intl.DateTimeFormatOptions = { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" },
  englishLocale = "en-US",
): string {
  return new Date(value).toLocaleString(dateLocale(englishLocale), options);
}

// "title, skills and experience" in English (en-GB, no Oxford comma, as the
// call sites wrote it), the language's own joiner in the others.
export function formatList(items: string[], englishLocale = "en-GB"): string {
  return new Intl.ListFormat(dateLocale(englishLocale), { style: "long", type: "conjunction" }).format(items);
}

export function formatNumber(value: number, options?: Intl.NumberFormatOptions): string {
  return new Intl.NumberFormat(uiLocale(), options).format(value);
}

// "5m ago" in English (unchanged), "vor 5 Min." in German. Under a minute is "just now".
export function formatTimeAgo(value?: DateInput): string {
  if (!value) return "";
  const minutes = Math.floor((Date.now() - new Date(value).getTime()) / 60000);
  if (minutes < 1) return t("just now");
  const locale = uiLocale();
  const rtf = new Intl.RelativeTimeFormat(locale, { style: locale === "en-US" ? "narrow" : "short", numeric: "always" });
  if (minutes < 60) return rtf.format(-minutes, "minute");
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return rtf.format(-hours, "hour");
  return rtf.format(-Math.floor(hours / 24), "day");
}
